import { render, staticRenderFns } from "./VideoYoutubeIframe.vue?vue&type=template&id=4599a59e&scoped=true&"
import script from "./VideoYoutubeIframe.vue?vue&type=script&lang=js&"
export * from "./VideoYoutubeIframe.vue?vue&type=script&lang=js&"
import style0 from "./VideoYoutubeIframe.vue?vue&type=style&index=0&id=4599a59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599a59e",
  null
  
)

export default component.exports